import { AuthService } from '../core/auth.service';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

@Injectable()
export class AdminPanelService {
  toggleAdminPanelVisibility$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private adminSidenav;
  public isAdminSidenavOpen = false;
  private wasAdminOpened = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private authService: AuthService
  ) {}

  initAdminPanel(adminSidenav) {
    this.adminSidenav = adminSidenav;
  }

  openAdminPanel() {
    if (!this.isAdminSidenavOpen) {
      this.adminSidenav._elementRef.nativeElement.previousSibling.previousSibling.className =
        ['mat-drawer-backdrop mat-drawer-shown'];
      this.adminSidenav._elementRef.nativeElement.style.transform =
        'translate3d(0,0,0)';
      this.adminSidenav._elementRef.nativeElement.style.visibility = 'visible';

      this.isAdminSidenavOpen = true;
      if (!this.wasAdminOpened) {
        this.wasAdminOpened = true;
        this.router.navigate([
          { outlets: { adminContent: 'admin/choose-section' } },
        ]);
      }
    }
  }

  closeAdminPanel() {
    if (this.isAdminSidenavOpen) {
      this.adminSidenav._elementRef.nativeElement.previousSibling.previousSibling.className =
        ['mat-drawer-backdrop'];
      this.adminSidenav._elementRef.nativeElement.style.transform =
        'translate3d(100%,0,0)';

      this.isAdminSidenavOpen = false;
    }
  }

  deleteAccount(): Observable<any> {
    return this.http
      .delete(environment.baseUrl + environment.api + 'users/current', {
        headers: this.authService.getJwtAuthHeaders(),
      })
      .pipe(
        tap(() => {
          this.authService.logout();
        })
      );
  }

  toggleAdminPanelVisibilityNextValue(isOpen: boolean): void {
    this.toggleAdminPanelVisibility.next(isOpen);
  }

  get toggleAdminPanelVisibility(): BehaviorSubject<boolean> {
    return this.toggleAdminPanelVisibility$;
  }
}
